import React, { Dispatch, SetStateAction, useState } from "react";
import PostDeleteSection from "../PostDeleteSection/PostDeleteSection";
import { AddInter } from "../../interface/interface";
import ToggleBtn from "../ToggleBtn/ToggleBtn";
import OrderArrow from "../OrderArrow/OrderArrow";
import FixBtn from "../FixBtn/FixBtn";
import { reg } from "../../lib/lib";
interface Props {
  index: number;
  data: AddInter;
  setDeleteIndex: Dispatch<SetStateAction<string | undefined>>;
  DeleteIndex: string | undefined;
  PostRemove: (data: any, id: string) => void;
  UpdateBlind: (e: boolean, index: number) => void;
  OrderChange: (e: string, index: number) => void;
  type: "add" | "line";
}

const AddCard = ({
  index,
  data,
  setDeleteIndex,
  DeleteIndex,
  PostRemove,
  UpdateBlind,
  OrderChange,
  type,
}: Props) => {
  const color = data.bg_color.replace(reg, "");
  const [isBlind, setisBlind] = useState(false);
  return (
    <div className={`add-card-comp`}>
      <div className="add-img">
        <img src={data.ad_thumbnail} alt="" />
      </div>
      <div className="add-title">
        <div
          className={`add-card-color ${
            color === "Green"
              ? "color-green"
              : color === "Purple"
              ? "color-purple"
              : color === "Blue"
              ? "color-blue"
              : color === "Skyblue"
              ? "color-sky-blue"
              : "color-black"
          }`}
        />
        <span> {data.ctts_tit}</span>
      </div>
      <div className="add-count">{data.ctts_hit_cnt}</div>
      <div className="add-show">
        <ToggleBtn isActive={isBlind} updateActive={UpdateBlind} index={2} />
      </div>
      <div className="add-index">
        <OrderArrow OrderChange={OrderChange} index={index} />
      </div>
      <div className="add-card-fix-btn">
        <FixBtn
          link={type === "add" ? `/add/fix` : "/add/line/fix"}
          state={data}
          style={{
            color: "white",
            backgroundColor: "black",
          }}
        />
      </div>
      <PostDeleteSection
        isOpen={DeleteIndex === data.ctts_id}
        ment="광고를 삭제하시겠습니까?"
        index={data.ctts_id}
        setDeleteIndex={setDeleteIndex}
        data={{ ctts_tit: data.ctts_tit, ctts_ctts: data.ctts_ctts }}
        PostRemove={PostRemove}
      />
    </div>
  );
};

export default AddCard;
